// Vendor imports
const { connect } = require('react-redux')
// Client V2 common imports
const withImmutableToJS = require('client-v2/common/components/immutable-to-js')
const withIsVisible = require('client-v2/common/components/is-visible')
// Cousin imports
const coverImageModalActions = require('../collection-edit-cover-image-modal/actions')
const headerImageModalActions = require('../collection-edit-header-image-modal/actions')
// Sibling imports
const actions = require('./actions')
const selectors = require('./selectors')

function mapStateToProps(state) {
  if (!selectors.isVisible(state)) {
    return { isVisible: false }
  }
  return {
    // Flags
    isCollectionDeletePending: selectors.isCollectionDeletePending(state),
    isCollectionUpdatePending: selectors.isCollectionUpdatePending(state),
    isHeaderImageUploadPending: selectors.isHeaderImageUploadPending(state),
    isVisible: true,
    // Values
    collection: selectors.collection(state),
    coverImage: selectors.coverImage(state),
    headerImage: selectors.headerImage(state)
  }
}

const mapDispatchToProps = {
  onCollectionDelete: actions.deleteCollection,
  onCollectionSubmit: actions.submitCollection,
  onCoverImageEdit: coverImageModalActions.show,
  onDismiss: actions.hide,
  onHeaderImageEdit: headerImageModalActions.show
}

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withIsVisible(
    withImmutableToJS(
      require('./component-dumb')
    )
  )
)
